export const NumberFormatterService = Symbol.for('NumberFormatterService');
